import { render, staticRenderFns } from "./ServiceListItem.vue?vue&type=template&id=312433ac&lang=pug&"
import script from "./ServiceListItem.vue?vue&type=script&lang=js&"
export * from "./ServiceListItem.vue?vue&type=script&lang=js&"
import style0 from "./ServiceListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports